import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import "../../../style";





class Features extends Component {
    render(){
        return(
            <Grid item sm={3} xs={12}>
                <div className="featureCard">
                    <div className="featureIcon">
                        <FontAwesomeIcon icon={faChartLine} className="featureSvg"/>
                    </div>
                    <h3 className="CardHead">Digitize Tickets</h3>
                    <p className="cardDescription">
                    Input production load
details once, reduce
entry error, and track
harvest data                    </p>
            </div>
            </Grid>
        );
    }
}

export default Features;


// WEBPACK FOOTER //
// ./src/components/public/Home/Features.js